const ticketsDataRequestAction = () => {
    return (dispatch, getState, { componentDataEngine }) => {
        const state = getState();
        const {
            gumbo: {
                gamePk
            },
            config: {
                language = 'en'
            }
        } = state;

        return componentDataEngine.fetchAndStore('schedule', { gamePk, language });
    };
};

export default ticketsDataRequestAction;
